import { action, observable } from 'mobx';
import { KaizenLabService } from '../entity/KaizenLabService';

export class KaizenLabServiceStore {
  public static deserializeFromApiResponse(res: any): KaizenLabService {
    const label = res.label;
    const name = res.name;
    const description = res.description;
    const url = res.url;
    const releaseStage = res.release_stage;
    const available = res.available;
    const permissions = res.permissions;
    return new KaizenLabService({ label, name, description, url, releaseStage, available, permissions });
  }

  @observable public kaizenLabServiceList = observable.map();

  @action
  public set(organizationId: string, res: any[]) {
    const serviceList: KaizenLabService[] = res.map((item: any) => {
      return KaizenLabServiceStore.deserializeFromApiResponse(item);
    });
    this.kaizenLabServiceList.set(organizationId, serviceList);
  }

  public getAll(organizationId: string): KaizenLabService[] {
    return (this.kaizenLabServiceList.get(organizationId) as KaizenLabService[]) || [];
  }

  public getOtherServices(organizationId: string): KaizenLabService[] {
    return this.getAll(organizationId).filter(service => service.label !== 'experience_portfolio');
  }

  public getExperiencePortfolioInfo(organizationId: string): KaizenLabService {
    return this.getAll(organizationId).filter(service => service.label === 'experience_portfolio')[0];
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/domain/store/KaizenLabServiceStore.ts